import { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import {toast} from "react-toastify";
import http from "../../Common/http-common";
import * as common from "../../Common/common";
import * as Comp from "../../Common/CommonComponents";
import { FaRegEye, FaEyeSlash } from "react-icons/fa";
import classes from "../../Styles/common.module.css";

const LoginResetPassword = (props) => {
  const userEmailInputRef = useRef();
  const userPasswordInputRef = useRef();
  const userCPasswordInputRef = useRef();

  const [newVisible, setNewVisible] = useState(false);

	const toggleNewPasswordVisibility = () => {
		setNewVisible(!newVisible);
	};

  const [reVisible, setReVisible] = useState(false);

	const toggleRePasswordVisibility = () => {
		setReVisible(!reVisible);
	};

  const onKeyDown = (event) => { 
		if (event.key === "Enter") 
      saveBtnOnClick();
	};

  const [editData, setEditData] = useState([]);
  const [inputError, setInputError] = useState([]);

  useEffect(() => {
    if (props.editData !== null) {
      // console.log("editData received:", props.editData);
      setEditData({
        USER_MST_GUID: props.editData.USER_MST_GUID === null ? "" : props.editData.USER_MST_GUID,
        USERNAME: props.editData.USERNAME === null ? "" : props.editData.USERNAME,
        EMAIL: props.editData.EMAIL === null ? "" : props.editData.EMAIL,
        ERROR_MSG: props.editData.ERROR_MSG === null ? "" : props.editData.ERROR_MSG,
      });
    }
    // var inputText = document.getElementById("CONFIRM_PASSWORD");
    // var saveBtn = document.getElementById("btnSave");
    // if (inputText && saveBtn) {
    //   inputText.onkeydown = (e) => { if (e.key === "Enter") saveBtn.click(); }
    // }
  }, [props.editData]);

  const hideModal = () => {
    setEditData([]);
    setInputError([]);
    props.onHide();
  };

  const saveBtnOnClick = () => {
    if (editData.PASSWORD === undefined) {
      setInputError((prevState) => ({
        ...prevState,
        PASSWORD: ("Password could not be empty."),
      }));
    } else {
      furtherValidateInput("PASSWORD", editData.PASSWORD)
    }
    if (editData.CONFIRM_PASSWORD === undefined) {
      setInputError((prevState) => ({
        ...prevState,
        CONFIRM_PASSWORD: ("Confirm Password could not be empty."),
      }));
    } else {
      furtherValidateInput("CONFIRM_PASSWORD", editData.CONFIRM_PASSWORD)
    }
    if (Object.values(inputError).filter(v => v !== "").length === 0) {
      ChangePassword();
    }
  };

  function ChangePassword() {
    if (editData.PASSWORD !== undefined && editData.CONFIRM_PASSWORD !== undefined) {
      let functionName = "";
      try {
        functionName = ChangePassword.name;
        props.onLoading(true, "Changing password, please wait...");
        var encrypted = common.c_EncryptData(editData.PASSWORD.trim());
        const data = {
          USER_MST_GUID: editData.USER_MST_GUID,
          USER_NAME: editData.USER_NAME,
          EMAIL: editData.EMAIL,
          PASSWORD: encrypted.toString(),
          FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
        };
        http
          .post("api/login/ChangePassword", data, { timeout: 5000 })
          .then((response) => {
            if (response.data.VALID === "PASSWORD_REPEAT" || response.data.VALID === "PASSWORD_INVALID") {
              setEditData(prevState => ({
                ...prevState,
                ERROR_MSG: response.data.ERROR_MSG,
              }))
            }
            else {
              toast.success("Reset password successfully.");
              hideModal();
              props.showHideLoginModal();
            }
          })
          .catch((err) => {
            toast.error("Failed to reset password. Please try again.");
            common.c_LogWebError(props.page, functionName, err);
          })
          .finally(() => {
            props.onLoading(false, "Loading...");
          });
      } catch (err) {
        props.onLoading(false, "Loading...");
        toast.error("Failed to reset password. Please try again.");
        common.c_LogWebError(props.page, functionName, err);
      }
    }
  };

  function furtherValidateInput(id, val) {
    if (id === "CONFIRM_PASSWORD") {
      var PASSWORD = editData.PASSWORD;
      if (PASSWORD !== val) {
        setInputError((prevState) => ({
          ...prevState,
          CONFIRM_PASSWORD: ("Please confirm the passwords are match."),
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          CONFIRM_PASSWORD: (""),
        }));
      }
    } else {
      var CPASSWORD = editData.CONFIRM_PASSWORD;
      if (CPASSWORD !== val) {
        setInputError((prevState) => ({
          ...prevState,
          CONFIRM_PASSWORD: ("Please confirm the passwords are match."),
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          CONFIRM_PASSWORD: (""),
        }));
      }
    }
  }

  const inputRequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputRequiredHandler.name;
      const name = event.target.name;
      functionName = inputRequiredHandler.name + "_" + name;
      const id = event.target.id;
      const val = event.target.value;
      if (val.length === 0 || val.trim().length === 0) {
        setInputError((prevState) => ({
          ...prevState,
          [id]: (name + " could not be empty."),
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          [id]: (""),
        }));
        furtherValidateInput(id, val);
      }
      setEditData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  }

  return (
    <>
      <Modal show={props.showHide} onHide={hideModal} centered>
        <Modal.Header>
          <div style={{ backgroundColor: "#FF8C00", width: "100%" }}>
            <Modal.Title>RESET PASSWORD</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Comp.Input
            ref={userEmailInputRef}
            id="EMAIL"
            label="Email:"
            type="text"
            className="form-control"
            value={editData.EMAIL}
            readOnly={true}
          />

          <div className="form-group">
						<label className={classes.colFormLabel}>Password*:</label>
						<div className={classes.modalPopupItem}>
							<div className="input-container">
								<input
									className="form-control"
									ref={userPasswordInputRef}
									type={newVisible ? 'text' : 'password'}
									id="PASSWORD"
									value={editData.PASSWORD}
									name="Password"
									onChange={inputRequiredHandler}
                  onKeyDown={onKeyDown}
								/>
								<div className="icon-container">
									{newVisible ? (
										<FaRegEye 
											className='icon' 
											onClick={toggleNewPasswordVisibility}
										/>
									) : (
										<FaEyeSlash
											className='icon' 
											onClick={toggleNewPasswordVisibility}
										/>
									)}
								</div>
							</div>	

							{inputError.PASSWORD !== "" && (
								<div className={classes.invalidMessage}>{inputError.PASSWORD}</div>
							)}
						</div>
					</div>

          <div className="form-group">
						<label className={classes.colFormLabel}>Confirm Password*:</label>
						<div className={classes.modalPopupItem}>
							<div className="input-container">
								<input
									className="form-control"
									ref={userCPasswordInputRef}
									type={reVisible ? 'text' : 'password'}
									id="CONFIRM_PASSWORD"
									value={editData.CONFIRM_PASSWORD}
									name="Confirm Password"
									onChange={inputRequiredHandler}
                  onKeyDown={onKeyDown}
								/>
								<div className="icon-container">
									{reVisible ? (
										<FaRegEye 
											className='icon' 
											onClick={toggleRePasswordVisibility}
										/>
									) : (
										<FaEyeSlash
											className='icon' 
											onClick={toggleRePasswordVisibility}
										/>
									)}
								</div>
							</div>	

							{inputError.CONFIRM_PASSWORD !== "" && (
								<div className={classes.invalidMessage}>{inputError.CONFIRM_PASSWORD}</div>
							)}
						</div>
					</div>
        </Modal.Body>
        <Modal.Footer>
          <div style={{ textAlign: "center", width: "100%" }}>
          <Comp.Button
              id="btnCancel"
              type="cancel"
              onClick={hideModal}
            >
              Cancel
            </Comp.Button>
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            <Comp.Button id="btnSave" onClick={saveBtnOnClick}>
              Confirm
            </Comp.Button>

            {editData.ERROR_MSG && editData.ERROR_MSG.split('\n').map((line, index) => (
              <p key={index} style={{ color: "rgb(255,0,0)", marginTop: "5px", fontSize: "smaller" }}>{line}</p>
            ))}
            {/* <p style={{ color: "rgb(255,0,0)", marginTop: "5px", fontSize: "smaller" }}>{editData.ERROR_MSG}</p> */}
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default LoginResetPassword;